/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://commenting-tool-demo-api-v2.geodemosolutions.com/public/'
  appBaseUrl = 'https://commenting-tool-demo-v2.geodemosolutions.com/#/'
  // baseApiUrl = 'https://comment-envi-tool-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://comment-envi-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/cprp-demo-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
